import { toast, ToastContent, ToastOptions } from 'components/Toast'

export function useErrors() {
  const showError = (content: ToastContent, options?: ToastOptions) => {
    toast.error(content, options)
  }
  return { showError }
}
